import axios, { AxiosError } from "axios";
import { store } from "../State/Store";
import { decPending, incPending, setGlobalError } from "../State/UiSlice";
import { MetaConfig, scheduleDecPending } from "./MetaConfig";

// api.ts
function normalizeError(err: unknown) {
  const ax = err as AxiosError<any>;
  const status = ax.response?.status;
  const data = ax.response?.data;
  

  // Try to extract a clean message from typical shapes (Spring, custom)
  let msg =
    (data && (data.message || data.error || data.detail)) ||
    (typeof data === "string" ? data : undefined) ||
    ax.message ||
    (status ? `HTTP ${status}` : "Network error, please try again.");

  // If Spring put the info in "trace", take the first line before "at "
  if (!msg && data?.trace && typeof data.trace === "string") {
    msg = data.trace.split("at ")[0].trim();
  }

  // Optional: friendly mapping for common cases
  if (status === 409 && /already exist/i.test(String(msg))) {
    msg = "User already exists. Please log in.";
  }

  return {
    status,
    message: msg,
    isNetworkError: !ax.response,
    code: ax.code,
    data, // keep raw for debugging, but don't render by default
  };
}


const BASE_API_URL = (process.env.REACT_APP_API_BASE_URL || "").trim(); 

export const api = axios.create({
  baseURL: BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  responseType: "json",
  withCredentials: true,
  timeout: 15000,
  // include cookies in the request
});

api.interceptors.request.use(
  (config) => {
    const meta = (config.meta ?? {}) as MetaConfig;
    if (!meta.skipLoader) {
      meta.loaderStartedAt = Date.now();
      store.dispatch(incPending())
    };
    config.meta = meta;
    return config;
  },
  (err) => {
    const cfg = err.config;
    const meta = cfg?.meta as MetaConfig | undefined;
    if (!meta?.skipLoader) store.dispatch(decPending());

    // Bị hủy → đừng show toast
    if (axios.isCancel(err) || err.code === "ERR_CANCELED") {
      return Promise.reject(normalizeError(err));
    }

    const norm = normalizeError(err);
    if (!meta?.silent) store.dispatch(setGlobalError(norm));
    return Promise.reject(norm);
  
  }
);

api.interceptors.response.use(
  (res) => {
    scheduleDecPending(res.config.meta as MetaConfig | undefined);
    return res;
  },
  (err) => {
    scheduleDecPending(err.config?.meta as MetaConfig | undefined);
    const norm = normalizeError(err);
    const meta = err.config?.meta as MetaConfig | undefined;
    if (!meta?.silent) store.dispatch(setGlobalError(norm));
    return Promise.reject(norm);
  }
);
